function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {_defineProperty(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}function _defineProperty(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { COLORS } from "../utils/colors";
import t from "../I18N/t";

const getTemplateInfo = createSelector(
(s) => s.templates,
(_s, p) => p.template,
(templates, currentTemplate) => {
  let styleProps;
  const name = templates.reduce((result, template, index) => {
    if (template.get('_id') === currentTemplate) {
      styleProps = template.get('color') ?
      { className: 'btn-color', style: { backgroundColor: template.get('color') } } :
      { className: `btn-color btn-color-${index % COLORS.length}` };
      return template.get('name');
    }
    return result;
  }, '');

  return { name, styleProps };
});


export class TemplateLabel extends Component {
  render() {
    const { name, template, className, style } = this.props;
    return /*#__PURE__*/(
      _jsx("span", { className: className, style: style }, void 0,
      template && t(template, name)));


  }
}

TemplateLabel.defaultProps = {
  className: 'btn-color',
  style: undefined
};








const mapStateToProps = (state, props) => {
  const template = getTemplateInfo(state, props);
  return _objectSpread({
    name: template.name,
    template: props.template },
  template.styleProps);

};

export default connect(mapStateToProps)(TemplateLabel);